/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cognito_identity_pool_id": "us-west-2:756ddab2-9b5c-4870-bd0c-74b5547d2df5",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_50B4ViMJA",
    "aws_user_pools_web_client_id": "467794oq34o66d6m259u2dt6i2",
    "oauth": {},
    "aws_cognito_login_mechanisms": [
        "PREFERRED_USERNAME"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "sbs-20211126164404-hostingbucket-dev",
    "aws_content_delivery_bucket_region": "us-west-2",
    "aws_content_delivery_url": "https://d3jo30ws9ea2c4.cloudfront.net",
    "aws_dynamodb_all_tables_region": "us-west-2",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "beedDevTable-dev",
            "region": "us-west-2"
        },
        {
            "tableName": "Beer-sbsdev",
            "region": "us-west-2"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://vpnesi6kc5drfeqdejqodvj2me.appsync-api.us-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-2",
    "aws_appsync_authenticationType": "AWS_IAM",
    "aws_appsync_apiKey": "da2-fakeApiId123456"
};


export default awsmobile;
